import {
  Formik,
  Mutation,
  React,
  SubmitAndReset,
  TextInput,
  Yup,
} from '@1337lawyers/design';

import * as CREATE_PORTAL_USER from './createPortalUser.gql';

interface ICreatePortalUserValues {
  personId: string;
  barJurisdiction: string;
  barNumber?: number;
}

export const CreatePortalUser = () => (
  <Mutation mutation={CREATE_PORTAL_USER}>
    {(createPortalUser, { data }) => (
      <Formik
        initialValues={{
          personId: '',
        }}
        onSubmit={async (
          values: ICreatePortalUserValues,
          { setSubmitting }
        ) => {
          setSubmitting(true);
          await createPortalUser({
            variables: { ...values },
          }).catch(() => {
            setSubmitting(false);
          });
          console.log(data);
          setSubmitting(false);
        }}
        validationSchema={Yup.object().shape({
          personId: Yup.string().required(),
        })}
        render={({
          values,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          errors,
          handleReset,
        }) => (
          <form onSubmit={handleSubmit}>
            <TextInput
              touched={touched}
              errors={errors}
              values={values}
              label="Person Id"
              handleBlur={handleBlur}
              handleChange={handleChange}
              value="personId"
            />

            <SubmitAndReset
              errors={errors}
              isSubmitting={isSubmitting}
              submitButtonText="Create PortalUser"
              handleReset={handleReset}
            />
          </form>
        )}
      />
    )}
  </Mutation>
);
